import { Container } from "reactstrap";

const Export = () => {
  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "500px" }}
    >
      <p
        className="text-center"
        style={{ fontWeight: "bold", color: "gray", fontSize: "20px" }}
      >
        Export
      </p>
    </Container>
  );
};
export default Export;
